/**
 * Multi-channel CRM OAuth result bridge.
 *
 * Chrome's COOP severs window.opener after the popup round-trips through
 * a cross-origin OAuth URL (HubSpot, Salesforce, Pipedrive, Zoho, etc.).
 * Plain opener.postMessage silently drops. Fan out via 3 channels:
 *   1. opener.postMessage  — works when COOP isn't strict
 *   2. BroadcastChannel    — works across same-origin tabs without opener
 *   3. localStorage event  — last-resort cross-tab signal
 */

const STORAGE_KEY = "crm_oauth_result";
const CHANNEL_NAME = "crm_oauth_result";

export const notifyCrmOAuth = (msg) => {
  try { if (window.opener) window.opener.postMessage(msg, "*"); } catch (e) {}
  try {
    const bc = new BroadcastChannel(CHANNEL_NAME);
    bc.postMessage(msg);
    bc.close();
  } catch (e) {}
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...msg, _ts: Date.now() }));
  } catch (e) {}
};

export const listenForCrmOAuth = (expectedType, callback) => {
  let lastTs = 0;

  const handle = (msg) => {
    if (!msg || msg.type !== expectedType) return;
    if (msg._ts && msg._ts === lastTs) return;
    if (msg._ts) lastTs = msg._ts;
    callback(msg);
  };

  const onMessage = (ev) => handle(ev?.data);
  window.addEventListener("message", onMessage);

  let bc;
  try {
    bc = new BroadcastChannel(CHANNEL_NAME);
    bc.onmessage = (ev) => handle(ev?.data);
  } catch (e) {}

  const onStorage = (ev) => {
    if (ev.key !== STORAGE_KEY || !ev.newValue) return;
    try { handle(JSON.parse(ev.newValue)); } catch (e) {}
  };
  window.addEventListener("storage", onStorage);

  return () => {
    window.removeEventListener("message", onMessage);
    window.removeEventListener("storage", onStorage);
    try { if (bc) bc.close(); } catch (e) {}
  };
};

export const clearCrmOAuthSignal = () => {
  try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
};
